import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./styles.module.scss";
import cx from "classnames";
import dateformat from "dateformat";
import TimeAgo from 'react-timeago';
import Loss from "../vectors/loss.svg";
import Gain from "../vectors/gain.svg";
import numeral from "numeral";
import InfiniteScroll from "react-infinite-scroller";
import moment from "moment";
import _ from "lodash";
import Tooltip from "src/components/tooltip"

import { localizedStrings } from "src/localization/index";
import withUseHooks from "src/legacy/components/withUseHooks";

class DealRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.handleClick = this.handleClick.bind(this);
    this.localizedCommons = localizedStrings.commons;
  }

  handleClick(deal) {
    this.props.navigate(`/deal-insights/${deal.id}`);
  }

  componentDidMount() {
  }

  formatNumber(value) {

    if (_.isNull(value) || _.isUndefined(value)) {
      return 0;
    }

    if (value % 1 !== 0) {
      return value.toFixed(2);
    }

    return value;

  }

  render() {

    return (
      <div className={styles.listContainer}>
        <InfiniteScroll
          pageStart={0}
          initialLoad={false}
          hasMore={this.props.currentPage < this.props.totalPages}
          loadMore={this.props.loadMoreDeals}
          useWindow={false}
          threshold={200}
        >
          <div className={styles.container} >
            {this.props.deals != null &&
              this.props.deals.map((deal) => {
                const aiConfidenceChange = _.round(_.get(deal, "aiConfidenceChange"), 0);
                return <div className={styles.dealContainer} onClick={() => this.handleClick(deal)}>
                  <Row className={styles.userData}>
                    <Col className={cx(styles.deal, styles.title)} md={2}>
                      {deal.title}
                    </Col>
                    <Col className={styles.deal} md={2}>
                      {deal.customer ? deal.customer : "-"}
                    </Col>
                    <Col className={styles.deal} md={1}>
                      {
                        _.get(deal, "value", 0) >= 0 ?
                          `$${_.round(_.get(deal, "value", 0))}` :
                          `-$${Math.abs(_.round(_.get(deal, "value", 0)))}`
                      }
                    </Col>
                    <Col className={cx(styles.deal, styles.centerAlign)} md={1}>

                      {aiConfidenceChange ?

                        <Tooltip placement="top" content={`${aiConfidenceChange}% ${this.localizedCommons.since} ${moment(_.get(deal, "aiConfidenceChangeDate")).format('DD MMM YYYY')}`}>
                          <label className={styles.dealLabel}>{numeral(_.get(deal, "aiConfidence", 0)).format("(0)")}%</label>
                          {aiConfidenceChange != 0 && <img className={styles.statusImage} src={aiConfidenceChange > 0 ? Gain : Loss} />}
                        </Tooltip> : `${numeral(_.get(deal, "aiConfidence", 0)).format("(0)")}%`}

                    </Col>
                    <Col className={cx(styles.deal, styles.centerAlign)} md={1}>
                      {numeral(_.get(deal, "teamConfidence", 0)).format("(0)")}%
                    </Col>
                    <Col className={cx(styles.deal, styles.centerAlign)} md={1}>
                      {deal.createdDate ? dateformat(deal.createdDate, "dd mmm yyyy") : "-"}
                    </Col>
                    <Col className={styles.deal} md={2}>
                      {deal.owner ? deal.owner : "-"}
                    </Col>
                    <Col className={cx(styles.deal, styles.centerAlign)} md={1}>
                      {deal.expectedCloseDate ? dateformat(deal.expectedCloseDate, "dd mmm yyyy") : "-"}
                    </Col>
                    <Col className={styles.deal} md={1}>
                      {_.get(deal, "lastActivityDate") ? <TimeAgo date={deal.lastActivityDate} live={false} /> : "-"}
                    </Col>
                  </Row>
                </div>
              })}
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}


export default withUseHooks(DealRow);